import { createSlice } from "@reduxjs/toolkit";

const initialState: {
    isAuthUser: boolean;
    isAuthAdmin: boolean,
    isShowBurgerMenu: boolean;
} = {
    isAuthUser: false,
    isAuthAdmin: false,
    isShowBurgerMenu: false,
};

const globalSlice = createSlice({
    initialState,
    name: "global",
    reducers: {
        logInUser(state) {
            state.isAuthUser = true;
        },
        logOutUser(state) {
            state.isAuthUser = false;
        },
        logInAdmin(state) {
            state.isAuthAdmin = true;
        },
        logOutAdmin(state) {
            state.isAuthAdmin = false;
        },

        showBurgerMenu(state) {
            state.isShowBurgerMenu = true;
        },
        hideBurgerMenu(state) {
            state.isShowBurgerMenu = false;
        }
    },
});

const { reducer, actions } = globalSlice;

export default reducer;

export const {
    logInUser,
    logOutUser,
    logInAdmin,
    logOutAdmin,

    showBurgerMenu,
    hideBurgerMenu
} = actions;
